//@flow
import { ILanguage } from "../action/types";
import {
  SIGNUP_REQUESTING,
  SIGNUP_INPUT_CHANGE,
  SIGNUP_PROGRESS_CHANGE,
  SIGNUP_STATS_CHANGE,
  SIGNUP_CHOICE_ADD,
  SIGNUP_CHOICE_REMOVE,
  SIGNUP_ONBOARDING_END_REQUESTING,
  SIGNUP_PROGRESS_CHANGE_RATIO,
  SIGNUP_CLICK_TOPIC,
  GET_CLIENT_REQUESTING,
  CHECK_MAGIC_CODE_REQUESTING,
} from "./constants";

type signupData = {
  email?: string;
  fullName?: string;
  password?: string;
  birthDate?: string;
  manager?: boolean;
  sexe?: string;
};

type signupStats = {
  confidence?: number;
  publicSpeaking?: number;
  teamSpirit?: number;
  stress?: number;
};

/*
{
  email: string,
  password: string,
  accessCode: string,
}
*/
// check pour changer ca, le seul endroit ou la fonction est appelé, envois seulement ses infos la
export const signupRequest = (payload: signupData) => {
  return {
    type: SIGNUP_REQUESTING,
    payload,
  };
};

/*
sex,
birthDate,
firstName,
lastName,
manager,
stats,
choice,
picture,
id,
PreferenceSignup.js appel cette fonction avec ces parametres, sinon aucun parametre dans tout les autres appel ^^
*/
// dans le saga, l'action n'est pas utilisé, il récupère les infos directement des selectors
// sais tu quel est la best practice ? envois dans la fonction ou récupération dans le saga
// je pense que le mieux est l'envois dans la fonction appelé, comme ca ca évite d'utiliser la fonction saga pour tout et n'importe quoi car les selector sont trop facile
export const signupOnboardingEndRequest = payload => {
  return {
    type: SIGNUP_ONBOARDING_END_REQUESTING,
    payload,
  };
};

// attention ici, il y a un put appelé dans le saga avec le type et non le nom de la fonction
// dans ce put, il envois un user et non des infos, je ne sais pas se que contient le user
export const changeSignupInput = (payload: {
  accessCode?: string;
  firstName?: string;
  lastName?: string;
  mbti?: string;
  email?: string;
  password?: string;
  phoneNumber?: string;
  goalNumber?: number;
}) => {
  return {
    type: SIGNUP_INPUT_CHANGE,
    payload,
  };
};

export const changeSignupProgress = (payload: number) => {
  return {
    type: SIGNUP_PROGRESS_CHANGE,
    payload,
  };
};

// ca va être le même type que les stats, il faudra faire attention à l'onboarding personnalisé
export const changeSignupStats = (payload: signupStats) => {
  return {
    type: SIGNUP_STATS_CHANGE,
    payload,
  };
};

// ce n'est pas un string. je ne sais pas ce que c'est
export const addSignupChoice = (payload: string) => {
  return {
    type: SIGNUP_CHOICE_ADD,
    payload,
  };
};

// même remarque que au dessus, ce sera le même type si on trouve
export const removeSignupChoice = (payload: string) => {
  return {
    type: SIGNUP_CHOICE_REMOVE,
    payload,
  };
};

// utilisé ?
export const changeRatioProgress = payload => {
  return {
    type: SIGNUP_PROGRESS_CHANGE_RATIO,
    payload,
  };
};

export const clickTopic = (payload: { value: String; title: ILanguage }) => {
  return {
    type: SIGNUP_CLICK_TOPIC,
    payload,
  };
};

export const getClientRequest = (payload: string) => {
  return {
    type: GET_CLIENT_REQUESTING,
    payload,
  };
};

export const checkMagicCodeRequest = (payload: { accessCode: string }) => {
  return {
    type: CHECK_MAGIC_CODE_REQUESTING,
    payload,
  };
};
